module.exports = __webpack_public_path__ + "img/product.b9a2653c.png";